import axios from "axios";

export default {
  namespaced: true,
  state: {
    projects: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    projectsMessage: ''
  },
  mutations: {
    CLEAR_CREATIVEPROJECTS(state) {
      state.projects = [];
    },
    DO_NOTHING(state) {
      state.isReceiving = state.isReceiving==true ? true : false;
    },
    RECEIVED_CREATIVEPROJECTS(state, payload) {
      state.projects = payload;
      state.isReceiving = false;
    },
    RECEIVING_CREATIVEPROJECTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_CREATIVEPROJECT(state, payload) {
      state = Object.assign(state, {
        projects: [...state.projects, payload],
        isReceiving: false,
      })
    },
    RECEIVING_CREATIVEPROJECT(state) {
      state.isReceiving = true;
    },
    UPDATED_CREATIVEPROJECT(state, payload) {
      let index = state.projects.findIndex(project => project._id === payload._id);
      state = Object.assign(state, {
        projects: state.projects.map((project, i) => {
          if (i === index) {
            return Object.assign({}, project, payload);
          }
          return project;
        }),
        isUpdating: false,
        projectsMessage: 'CreativeProjects has been updating!',
      })
    },
    UPDATING_CREATIVEPROJECT(state) {
      state.isUpdating = true;
    },
    DELETED_CREATIVEPROJECT(state, payload) {
      let indexToDelete = state.projects.findIndex(project => project._id === payload._id);
      let projects = [...state.projects];
      projects.splice(indexToDelete, 1);
      state = Object.assign(state, {
        projects: [...projects],
        isDeleting: false,
        idToDelete: null,
        projectsMessage: 'CreativeProject has been Deleted!',
      });
    },
    DELETING_CREATIVEPROJECT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteCreativeProjectRequest({dispatch}, payload) {
      dispatch("deletingCreativeProject", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.accountxc.com:3100/delete/creativeproject/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteCreativeProject", {_id: response.data._id});
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectTimeRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/creativetime/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteProjectMediaRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/creativemedia/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteProjectMessageRequest({dispatch}, payload) {
      try{
        dispatch("doNothing", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.accountxc.com:3100/delete/creativemessage/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertCreativeProjectRequest({dispatch}, payload) {
      dispatch("receivingCreativeProjects");
      var token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/creativeproject';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveCreativeProject", response.data);
      return response.data;
    },
    async insertCreativeProjectWithImageRequest({dispatch}, payload) {
      dispatch("receivingCreativeProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/insert/creativeproject/withimage';
      let data = new FormData();
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x]);
      
      return axios({method: "post", url: url, headers: headers , data: data})
      .then(response =>{
        dispatch("receiveCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.reponse.data.error;
      });	
    },
    async insertProjectTimeRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/creativetime/' + payload.id;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectMediaRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/creativemedia/' + payload.id;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectMessageRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/creativemessage/' + payload.id;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectSystemMessageRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/insert/creativemessage/system/' + payload.id;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },

    async insertProjectMediaWithFileRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/creativemedia/withfile/' + payload.id;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.file, payload.filename); 
        delete payload['file'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectMessageWithFileRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/creativemessage/withfile/' + payload.id;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.file, payload.filename); 
        delete payload['file'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectSystemMessageWithFileRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let url = 'https://api.accountxc.com:3100/insert/creativemessage/system/withfile/' + payload.id;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.file, payload.filename); 
        delete payload['file'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getCreativeProjectsTeamRequest({dispatch}) {
      dispatch("receivingCreativeProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/creativeprojects/team';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveCreativeProjects", response.data);
      })
    },
    async getCreativeProjectsRequest({dispatch}) {
      dispatch("receivingCreativeProjects");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/creativeprojects';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        dispatch("receiveCreativeProjects", response.data);
      })
    },
    async findCreativeProjectsRequest({dispatch}, payload) {
      try{
        dispatch("receivingCreativeProjects");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/creativeprojects';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveCreativeProjects", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findCreativeProjectsTeamRequest({dispatch}, payload) {
      try{
        dispatch("receivingCreativeProjects");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/creativeprojects/team';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveCreativeProjects", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateCreativeProjectRequest({dispatch}, payload) {
      dispatch("updatingCreativeProject");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/creativeproject/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateCreativeProjectAssignRequest({dispatch}, payload) {
      dispatch("updatingCreativeProject");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/creativeproject/assign/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateCreativeProjectResponseRequest({dispatch}, payload) {
      dispatch("updatingCreativeProject");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/creativeproject/response/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateCreativeProjectFinalizeRequest({dispatch}, payload) {
      dispatch("updatingCreativeProject");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/creativeproject/finalize/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateCreativeProjectImageRequest({dispatch}, payload) {
      dispatch("updatingCreativeProject");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.accountxc.com:3100/update/creativeproject/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateCreativeProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    clearCreativeProjects({commit}) {
      commit("CLEAR_CREATIVEPROJECTS")
    },
    receiveCreativeProjects({commit}, payload) {
      commit("RECEIVED_CREATIVEPROJECTS", payload)
    },
    receivingCreativeProjects({commit}) {
      commit("RECEIVING_CREATIVEPROJECTS")
    },
    receiveCreativeProject({commit}, payload) {
      commit("RECEIVED_CREATIVEPROJECT", payload)
    },
    receivingCreativeProject({commit}) {
      commit("RECEIVING_CREATIVEPROJECT")
    },
    updateCreativeProject({commit}, payload) {
      commit("UPDATED_CREATIVEPROJECT", payload)
    },
    updatingCreativeProject({commit}) {
      commit("UPDATING_CREATIVEPROJECT")
    },
    deleteCreativeProject({commit}, payload) {
      commit("DELETED_CREATIVEPROJECT", payload)
    },
    deletingCreativeProject({commit}, payload) {
      commit("DELETING_CREATIVEPROJECT", payload)
    }
  },
};
